
import React from 'react';
import logo from '../images/soter_logo.png';
function Logo(props) {
  const { height, width } = props;
  const style = { "height": height ? `${height}px` : "auto", "width": width ? `${width}px` : "auto" };
  return (
    <img src={logo} style={style} className="img-fluid" alt="StudentHealthPass" loading="lazy" />
  );
}
export default Logo;